import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { NetworkEffects } from './network-effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EffectsModule.forFeature(NetworkEffects)
  ]
})
export class NetworkFeatureStoreModule {
}
